import { gql } from "@apollo/client"

export const CHECK_DOCUMENT = gql`
  query ($documentNumber: String!) {
    checkDocumentIsReadyToDelivery(documentNumber: $documentNumber) {
      data
      message
    }
  }
`
